// TODO: image_url is null for all records - update with actual image URLs after image upload API is integrated
/**
 * Dummy data — 쇼핑
 * API_DOCS: 10. 쇼핑 (서비스) / 24. 관리자 - 쇼핑
 *
 * ShoppingProductResponse:
 *   id(int), category(string?), name(string?), description(string?),
 *   price(decimal?), image_url(string?), is_active(boolean), created_at(datetime)
 *
 * CartItemResponse: id(int), shopping_id(int?), quantity(int), created_at(datetime)
 * OrderResponse: id(int), order_number(string?), total_price(decimal?), status(string),
 *   paid_at(datetime?), delivered_at(datetime?), created_at(datetime)
 */

const products = [
  { id: 1, category: 'other', name: '프라이빗 쇼핑 - 명품 아울렛 투어', description: '여주/이천 프리미엄 아울렛에서 편안한 쇼핑을 즐기세요.', price: 280000, image_url: null, is_active: true, created_at: '2026-01-01T00:00:00' },
  { id: 2, category: 'other', name: '프라이빗 쇼핑 - 강남 럭셔리 투어', description: '청담·압구정 명품 거리 쇼핑 서비스.', price: 200000, image_url: null, is_active: true, created_at: '2026-01-10T00:00:00' },
  { id: 3, category: 'oliveyoung', name: '올리브영 뷰티 쇼핑 투어', description: '인기 K-뷰티 제품을 한번에 쇼핑하세요.', price: 150000, image_url: null, is_active: true, created_at: '2026-01-20T00:00:00' },
  { id: 4, category: 'mart', name: '대형마트 식품 쇼핑 투어', description: '이마트/코스트코에서 한국 식품을 구매하세요.', price: 120000, image_url: null, is_active: true, created_at: '2026-02-01T00:00:00' },
  { id: 5, category: 'daiso', name: '다이소 생활용품 쇼핑 투어', description: '다이소에서 알찬 생활용품을 쇼핑하세요.', price: 100000, image_url: null, is_active: false, created_at: '2026-02-10T00:00:00' },
];

const cart = [
  { id: 1, shopping_id: 1, quantity: 1, created_at: '2026-03-01T10:00:00' },
  { id: 2, shopping_id: 3, quantity: 2, created_at: '2026-03-02T14:00:00' },
];

const orders = [
  { id: 1, order_number: 'ORD-20260301001', total_price: 280000, status: 'paid', paid_at: '2026-03-01T11:00:00', delivered_at: null, created_at: '2026-03-01T10:30:00' },
  { id: 2, order_number: 'ORD-20260302001', total_price: 200000, status: 'shipped', paid_at: '2026-03-02T15:00:00', delivered_at: null, created_at: '2026-03-02T14:30:00' },
  { id: 3, order_number: 'ORD-20260225001', total_price: 150000, status: 'completed', paid_at: '2026-02-25T10:00:00', delivered_at: '2026-02-26T14:00:00', created_at: '2026-02-25T09:30:00' },
];

/* ── 소매 개별 상품 (ShoppingSelectModal용) ── */
const retailProducts = [
  { id: 101, category: '올리브영', name: '라운드랩 자작나무 수분크림', price: 15000, description: '수분 보습 크림', image_url: null },
  { id: 102, category: '올리브영', name: '토리든 다이브인 세럼', price: 22000, description: '저분자 히알루론산 세럼', image_url: null },
  { id: 103, category: '올리브영', name: '메디힐 티트리 마스크팩 10매', price: 12000, description: '진정 마스크팩', image_url: null },
  { id: 104, category: '올리브영', name: '이니스프리 그린티 세트', price: 35000, description: '그린티 스킨케어 세트', image_url: null },
  { id: 105, category: '올리브영', name: '조선미녀 맑은쌀 선크림', price: 18000, description: 'SPF50+ 선크림', image_url: null },
  { id: 106, category: '다이소', name: '미니 수납함 세트', price: 3000, description: '다용도 수납함', image_url: null },
  { id: 107, category: '다이소', name: '감성 마스킹테이프 5종', price: 2000, description: '데코레이션용 테이프', image_url: null },
  { id: 108, category: '다이소', name: '접이식 에코백', price: 1500, description: '휴대용 장바구니', image_url: null },
  { id: 109, category: '마트', name: '신라면 멀티팩 5입', price: 4500, description: '한국 대표 라면', image_url: null },
  { id: 110, category: '마트', name: '비비고 만두 350g', price: 8900, description: '냉동 만두', image_url: null },
  { id: 111, category: '마트', name: '오리온 초코파이 12개입', price: 5500, description: '초콜릿 파이', image_url: null },
  { id: 112, category: '기타', name: '한국 전통 기념품 세트', price: 25000, description: '한복 인형 + 부채 세트', image_url: null },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ── 서비스 (유저용) ── */

/** GET /api/shopping/retail-products (소매 개별 상품) */
export const getRetailProducts = async (params = {}) => {
  await delay(200);
  let filtered = [...retailProducts];
  if (params.category) filtered = filtered.filter((p) => p.category === params.category);
  if (params.search) {
    const q = params.search.toLowerCase();
    filtered = filtered.filter((p) => p.name.toLowerCase().includes(q));
  }
  return filtered;
};

/** GET /api/shopping/retail-categories */
export const getRetailCategories = async () => {
  await delay(100);
  const cats = [...new Set(retailProducts.map((p) => p.category))];
  return cats.map((c) => ({ id: c, label: c }));
};

/** GET /api/shopping/products */
export const getShoppingProducts = async (params = {}) => {
  await delay(300);
  let filtered = products.filter((p) => p.is_active);
  if (params.category) filtered = filtered.filter((p) => p.category === params.category);
  return filtered;
};

/** GET /api/shopping/products/:id */
export const getShoppingProductById = async (id) => {
  await delay(200);
  const found = products.find((p) => p.id === Number(id));
  if (!found) throw new Error('상품을 찾을 수 없습니다');
  return found;
};

/** GET /api/shopping/cart */
export const getCart = async () => {
  await delay(200);
  return cart;
};

/** POST /api/shopping/cart */
export const addToCart = async (data) => {
  await delay(300);
  const item = { id: cart.length + 1, shopping_id: data.shopping_id, quantity: data.quantity || 1, created_at: new Date().toISOString() };
  cart.push(item);
  return { message: '장바구니에 추가되었습니다' };
};

/** PUT /api/shopping/cart/:cartId */
export const updateCartItem = async (cartId, data) => {
  await delay(300);
  const found = cart.find((c) => c.id === Number(cartId));
  if (!found) throw new Error('장바구니 항목을 찾을 수 없습니다');
  found.quantity = data.quantity;
  return { message: '수량이 변경되었습니다' };
};

/** DELETE /api/shopping/cart/:cartId */
export const deleteCartItem = async (cartId) => {
  await delay(300);
  const idx = cart.findIndex((c) => c.id === Number(cartId));
  if (idx === -1) throw new Error('장바구니 항목을 찾을 수 없습니다');
  cart.splice(idx, 1);
  return { message: '장바구니에서 삭제되었습니다' };
};

/** POST /api/shopping/orders */
export const createOrder = async (data) => {
  await delay(400);
  const order = { id: orders.length + 1, order_number: `ORD-${Date.now()}`, total_price: 0, status: 'pending', paid_at: null, delivered_at: null, created_at: new Date().toISOString() };
  orders.push(order);
  return order;
};

/** GET /api/shopping/orders */
export const getOrders = async (params = {}) => {
  await delay(300);
  return orders;
};

/** GET /api/shopping/orders/:id */
export const getOrderById = async (id) => {
  await delay(200);
  const found = orders.find((o) => o.id === Number(id));
  if (!found) throw new Error('주문을 찾을 수 없습니다');
  return found;
};

/* ── 관리자 ── */

/** GET /api/admin/shopping/products (페이지네이션) */
export const getAdminProducts = async (params = {}) => {
  await delay(300);
  const page = params.page || 1;
  const size = params.size || 20;
  const start = (page - 1) * size;
  return {
    items: products.slice(start, start + size),
    total: products.length,
    page,
    size,
    pages: Math.ceil(products.length / size),
  };
};

/** POST /api/admin/shopping/products */
export const createAdminProduct = async (data) => {
  await delay(400);
  const product = { id: products.length + 1, category: data.category, name: data.name, description: data.description || null, price: data.price || null, image_url: data.image_url || null, is_active: true, created_at: new Date().toISOString() };
  products.push(product);
  return product;
};

/** PUT /api/admin/shopping/products/:id */
export const updateAdminProduct = async (id, data) => {
  await delay(400);
  const idx = products.findIndex((p) => p.id === Number(id));
  if (idx === -1) throw new Error('상품을 찾을 수 없습니다');
  products[idx] = { ...products[idx], ...data };
  return products[idx];
};

/** DELETE /api/admin/shopping/products/:id */
export const deleteAdminProduct = async (id) => {
  await delay(300);
  const idx = products.findIndex((p) => p.id === Number(id));
  if (idx === -1) throw new Error('상품을 찾을 수 없습니다');
  products.splice(idx, 1);
  return { message: '상품이 삭제되었습니다' };
};

/** GET /api/admin/shopping/orders (페이지네이션) */
export const getAdminOrders = async (params = {}) => {
  await delay(300);
  const page = params.page || 1;
  const size = params.size || 20;
  const start = (page - 1) * size;
  return {
    items: orders.slice(start, start + size),
    total: orders.length,
    page,
    size,
    pages: Math.ceil(orders.length / size),
  };
};

/** PUT /api/admin/shopping/orders/:id/status */
export const updateAdminOrderStatus = async (id, status) => {
  await delay(300);
  const found = orders.find((o) => o.id === Number(id));
  if (!found) throw new Error('주문을 찾을 수 없습니다');
  found.status = status;
  return { message: '상태가 변경되었습니다' };
};

/* ── 부분환불 (dummy) ── */

function dummyOrderDetail(id) {
  const o = orders.find((x) => x.id === Number(id)) || orders[0];
  return {
    id: o.id, order_number: o.order_number, total_price: o.total_price,
    status: o.status, refund_reason: null, pay_method: 'card',
    payment_method_label: '신용카드', paid_at: o.paid_at,
    delivered_at: o.delivered_at, created_at: o.created_at,
    items: [
      { id: 1, shopping_id: 105, name: '조선미녀 맑은쌀 선크림', quantity: 5, refunded_quantity: 0, refundable_quantity: 5, unit_price: 18000, line_total: 90000 },
      { id: 2, shopping_id: 101, name: '라운드랩 자작나무 수분크림', quantity: 2, refunded_quantity: 0, refundable_quantity: 2, unit_price: 15000, line_total: 30000 },
    ],
    refunds: [],
    latest_rejection_reason: null,
  };
}

export const requestShoppingRefund = async () => { await delay(300); return { message: 'Refund request submitted' }; };
export const getAdminOrderDetail = async (id) => { await delay(200); return dummyOrderDetail(id); };
export const operatorRefund = async () => { await delay(300); return { message: 'Refund processed' }; };
export const getRefundRequests = async (params = {}) => {
  await delay(200);
  return { items: [], total: 0, page: params.page || 1, size: params.size || 20, pages: 0 };
};
export const approveRefundRequest = async () => { await delay(300); return { message: 'approved' }; };
export const rejectRefundRequest = async () => { await delay(300); return { message: 'rejected' }; };
